import React from 'react';
import { motion } from 'framer-motion';
import { EASE } from '../motion/variants';

const cardEntrance = {
  hidden: { opacity: 0, y: 28 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, delay: i * 0.08, ease: EASE },
  }),
};

export default function CaseStudyCard({ study, index = 0, reduceMotion = false }) {
  const accent = study.accent || 'blue';
  const publicUrl = process.env.PUBLIC_URL || '';

  return (
    <motion.article
      className="cs-card cs-card--animated"
      data-accent={accent}
      custom={index}
      variants={cardEntrance}
      whileHover={
        reduceMotion
          ? undefined
          : {
              y: -8,
              transition: { type: 'spring', stiffness: 300, damping: 22 },
            }
      }
      whileTap={reduceMotion ? undefined : { scale: 0.99 }}
    >
      <span className="cs-card__shine" aria-hidden="true" />
      {study.image ? (
        <div className="cs-card__visual" data-accent={accent}>
          <img
            src={`${publicUrl}/images/case-studies/${study.image}`}
            alt={study.title}
            loading="lazy"
            decoding="async"
          />
        </div>
      ) : null}
      <span className="cs-card__tag">{study.tag}</span>
      <div className="cs-card__meta">
        {study.productLine} · {study.polymer}
      </div>
      <h3>{study.title}</h3>
      <p>{study.summary}</p>
    </motion.article>
  );
}
